/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 6/24/14
 * Time: 5:21 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var _ = require("underscore");

    var NotificationCenter = function () {
        var appenders = {};

        var initialize = function(options) {
            this.App = options.application;
            this.App.vent.on("notificationCenter:notify", function(options){
                notify(options);
            });
        };

        var notify = function(options){

            var returnObj = {};
            for (var appender in appenders) {
                var appenderOptions = options[appender];
                if (appenders[appender].isEnabled() && appenders[appender].isValidOptions(appenderOptions)) {
                    //set options
                    appenderOptions = _.extend(appenders[appender].getDefaultOptions(), appenderOptions);
                    var ret = appenders[appender].notify(appenderOptions);

                    if (ret) {
                        returnObj[appender] =ret;
                    }
                }
            }
            return returnObj;
        };

        var clearAllNotifications = function(options) {

        };

        var clearNotification = function(options) {
            var returnObj = {};
            for (var appender in appenders) {
                var appenderOptions = options[appender];
                if (appenders[appender].isEnabled() && appenders[appender].clearNotification) {
                    //set options
                    appenderOptions =  _.extend(appenders[appender].getDefaultOptions(), appenderOptions);
                    var ret = appenders[appender].clearNotification(appenderOptions);
                    if(ret) {
                        returnObj[appender] = ret;
                    }
                }
            }
            return returnObj;
        };
        var addAppender = function (options) {
          if (!options && !options.name && !options.appender) {
              return;
          }
          if (options.appender.isSupported()) {
               //notificationOptions[options.name]=options.appender.getOptions();
               appenders[options.name] = options.appender;
          }
        };

        return {
            addAppender:addAppender,
            initialize:initialize,
            notify:notify,
            clearNotification:clearNotification,
            clearAllNotifications:clearAllNotifications
        };
    };

    return NotificationCenter;
});
